<span fxLayout="column" class="mat-app-background-1">
  <span fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="center start" class="overflow-hidden">
    <span fxLayout="column" fxFill fxFlex="0 1 900px" fxFlex.sm="100" fxFlex.xs="100" class="position-relative">
      <span fxLayout="column" fxLayoutGap="20px" fxFlex.xs="100" fxFlex="100" fxFill class="res-img-height506-width100 image-ratio-container"
        >
        <img *ngIf="picture" width="100%" class="object-fit-cover absolute-zero" [src]="picture | safe: 'resourceUrl'"
          [alt]="redtextData?.title" (error)="onImgError()" />
      </span>
    </span>
  </span>
  <span fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center start">
    <span fxLayout="row" fxLayout.xs="column" fxLayoutGap="40px" fxLayout.sm="column" fxFlexAlign="start center"
      fxFlex="0 1 900px" fxFlex.xs="100" fxFlex.sm="100" class="res-pad-lr-0-20">


      <!-- content text 60% wide if there are boxes or pdfs -->
      <span fxLayout="column" fxFlex="0 0 60"
        *ngIf="redtextData?.box1 || redtextData?.box2
      || redtextData?.box3 || redtextData?.pdfuri || redtextData?.pdfuri2 || redtextData?.pdfuri3 || redtextData?.pdfuri4 || redtextData?.pdfuri5">


        <a *ngIf="routerLink" fxLayout="row" [routerLink]="routerLink" fxLayoutGap="10px"
          class="overline-margin primary-color mat-headline-1 clickable text-decoration-none image-overline-gap">
          <div>{{redtextData?.rubrik.name}}</div>
          <div *ngIf="( redtextData?.published == false)">{{'redtext.unpublished' | translate}}</div>
        </a>
        <div *ngIf="!routerLink" class="overline-margin primary-color mat-headline-1 text-decoration-none image-overline-gap">
          <div>{{redtextData?.rubrik.name}}</div>
          <div *ngIf="(redtextData?.published == false)">{{'redtext.unpublished' | translate}}</div>
        </div>


        <!-- <span fxLayout="row" class="title-margin mat-headline-2 overline-title-gap">{{redtextData?.title}}</span> -->
        <h1 fxLayout="row" class="title-margin mat-headline-2 overline-title-gap">{{redtextData?.title}}</h1>

        <markdown #mkMain *ngIf="redtextData?.content" class="mat-typography title-content-gap-redtext"
        [data]="redtextData?.content.replace('\r\n\r\n\r\n', '\r\n<br><br>\r\n')" (ready)="mkReady(mkMain)"> </markdown>
      </span>

      <!-- content text 100% wide if there are no boxes or pdfs -->
      <span fxLayout="column" fxFlex="0 0 100"
        *ngIf="!(redtextData?.box1 || redtextData?.box2
      || redtextData?.box3 || redtextData?.pdfuri || redtextData?.pdfuri2 || redtextData?.pdfuri3 || redtextData?.pdfuri4 || redtextData?.pdfuri5)">

        <span>
          <a *ngIf="routerLink" fxLayout="row" [routerLink]="routerLink" fxLayoutGap="10px"
            class="overline-margin primary-color mat-headline-1 clickable text-decoration-none image-overline-gap">
            <div>{{redtextData?.rubrik.name}}</div>
            <div *ngIf="(redtextData?.published == false)">{{'redtext.unpublished' | translate}}</div>
          </a>
          <div *ngIf="!routerLink" class="overline-margin primary-color mat-headline-1 text-decoration-none image-overline-gap">
            <div>{{redtextData?.rubrik.name}}</div>
            <div *ngIf="(redtextData?.published == false)">{{'redtext.unpublished' | translate}}</div>
          </div>


          <span fxLayout="row" class="title-margin mat-headline-2 overline-title-gap">{{redtextData?.title}}</span>
        </span>
        <markdown #mkMain *ngIf=" redtextData?.content" class="mat-typography title-content-gap-redtext"
          [data]="redtextData?.content.replace('\r\n\r\n\r\n', '\r\n<br><br>\r\n')" (ready)="mkReady(mkMain)"> </markdown>
      </span>
      <span fxLayout="column" fxFlex="40" fxLayoutGap="20px" class="image-overline-gap-LOCAL"
        *ngIf="redtextData?.box1 || redtextData?.box2
          || redtextData?.box3 || redtextData?.pdfuri || redtextData?.pdfuri2 || redtextData?.pdfuri3 || redtextData?.pdfuri4 || redtextData?.pdfuri5">
        <span class="flimmo-card box" *ngIf="redtextData?.box1">
          <markdown #mkBox1 [data]="redtextData?.box1" class="mat-typography" (ready)="mkReady(mkBox1)"></markdown>
        </span>
        <span class="flimmo-card box" *ngIf="redtextData?.box2">
          <markdown #mkBox2 [data]="redtextData?.box2" class="mat-typography" (ready)="mkReady(mkBox2)"></markdown>
        </span>
        <span class="flimmo-card box" *ngIf="redtextData?.box3">
          <markdown #mkBox3 [data]="redtextData?.box3" class="mat-typography" (ready)="mkReady(mkBox3)"></markdown>
        </span>
        <button mat-raised-button color="primary" (click)="openUri(redtextData?.pdfuri)" [disableRipple]="true"
          class="p-2 flimmo-button-1" *ngIf="redtextData?.pdfuri">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon color="white">picture_as_pdf</mat-icon>
            <a class="text-decoration-none mat-white mat-subtitle-2 ellipsis overflow-hidden mb-0">
              {{redtextData?.pdfname || getFileName(redtextData?.pdfuri)}}
            </a>
          </div>
        </button>
        <button mat-raised-button color="primary" (click)="openUri(redtextData?.pdfuri2)" [disableRipple]="true"
          class="p-2 flimmo-button-1" *ngIf="redtextData?.pdfuri2">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon color="white">picture_as_pdf</mat-icon>
            <a class="text-decoration-none mat-white mat-subtitle-2 ellipsis overflow-hidden mb-0">
              {{redtextData?.pdfname2 || getFileName(redtextData?.pdfuri2)}}
            </a>
          </div>
        </button>
        <button mat-raised-button color="primary" (click)="openUri(redtextData?.pdfuri3)" [disableRipple]="true"
          class="p-2 flimmo-button-1" *ngIf="redtextData?.pdfuri3">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon color="white">picture_as_pdf</mat-icon>
            <a class="text-decoration-none mat-white mat-subtitle-2 ellipsis overflow-hidden mb-0">
              {{redtextData?.pdfname3 || getFileName(redtextData?.pdfuri3)}}
            </a>
          </div>
        </button>
        <button mat-raised-button color="primary" (click)="openUri(redtextData?.pdfuri4)" [disableRipple]="true"
          class="p-2 flimmo-button-1" *ngIf="redtextData?.pdfuri4">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon color="white">picture_as_pdf</mat-icon>
            <a class="text-decoration-none mat-white mat-subtitle-2 ellipsis overflow-hidden mb-0">
              {{redtextData?.pdfname4 || getFileName(redtextData?.pdfuri4)}}
            </a>
          </div>
        </button>
        <button mat-raised-button color="primary" (click)="openUri(redtextData?.pdfuri5)" [disableRipple]="true"
          class="p-2 flimmo-button-1" *ngIf="redtextData?.pdfuri5">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon color="white">picture_as_pdf</mat-icon>
            <a class="text-decoration-none mat-white mat-subtitle-2 ellipsis overflow-hidden mb-0">
              {{redtextData?.pdfname5 || getFileName(redtextData?.pdfuri5)}}
            </a>
          </div>
        </button>
      </span>
    </span>
  </span>

  <span fxFlex="40px"></span>

  <div *ngIf="redtextData?.swimlane">
    <swimlanes [bigCards]="redtextData?.swimlane.size ==='l'" [swimlane]="redtextData?.swimlane" />
  </div>

  <span *ngIf="redtextData?.imagec" fxLayout="row" fxLayoutAlign="center start" fxFlexOffset="20px" fxLayoutGap="20px">
    <span fxLayout="column" fxLayoutGap="20px" fxFlex="0 1 900px" fxFlex.xs="100" fxFlex.sm="100"
      class="res-pad-lr-0-20">
      <span fxLayout="row" fxLayoutGap="10px" class="opaquetexts-color" fxLayoutAlign="start center">
        <span fxLayout="column">
          <span class="f-copyright">{{'common.copyrightTitle' | translate}}</span>
          <span class="f-copyright-text">{{redtextData?.imagec}}</span>
        </span>
      </span>
    </span>
  </span>
  <span fxFlex="50px"></span>
</span>
